<template>
  <div class="streams-list">
    <div class="streams-title-row subtitle">
      Streams
      <!-- Add stream button -->
      <span class="manage-icon add-icon" @click="showAddStreamModal">+</span>
      <!-- Remove stream button -->
      <span
        v-if="streams.length > 0"
        class="manage-icon remove-icon"
        @click="showRemoveStreamModal"
        >&#x274C;</span
      >
    </div>

    <!-- Streams list -->
    <template v-if="streams.length > 0">
      <div class="info-streams info-streams__wrapper">
        <div class="info-stream-row title-row">
          <div class="field recorder-field">
            <span>Source status</span>
          </div>
          <div class="field status-field">
            <span>Recorder status</span>
          </div>
          <div class="field name-field">
            <span>Name</span>
          </div>
          <div class="field type-field">
            <span>Type</span>
          </div>
          <div class="field url-field">
            <span>URL</span>
          </div>
          <div class="field url-field">
            <span>Clips</span>
          </div>
          <div class="field actions-field">
            <span>Actions</span>
          </div>
        </div>
        <stream-info
          v-for="stream in streams"
          :key="stream.streamName"
          :stream-info="stream"
          @showSource="showSourceModal($event)"
          @showRecorder="showRecorderModal($event)"
          @updateServerInfoFlag="$emit('updateServerInfoFlag', $event)"
          @showStreamInfo="showStreamInfoModal($event)"
          @editStream="showEditStreamModal($event)"
          @removeStream="showRemoveStreamModal($event)"
        />
      </div>
    </template>

    <!-- No streams template -->
    <template v-else>
      <span>No streams</span>
    </template>
  </div>
</template>

<script>
import StreamInfo from "@/components/admin/main/server/StreamInfo.vue";

/** Vuex methods */
import { mapActions, mapState } from "vuex";

// @group Admin Page
// Server streams list
export default {
  name: "AdminStreamsList",
  components: {
    StreamInfo
  },
  props: {
    // streams
    streams: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState({ modals: state => state.modals.admin.MODALS })
  },
  methods: {
    ...mapActions("modals", ["openAdminModal"]),
    // @vuese
    // Add new stream
    showAddStreamModal() {
      /** Open add stream modal */
      this.$emit("streamAddingStarted");
    },
    // @vuese
    // Open edit stream modal
    showEditStreamModal(stream) {
      this.openAdminModal({
        modal: this.modals.EDIT,
        data: { stream }
      });
    },
    // @vuese
    // Open remove stream modal
    showRemoveStreamModal(stream) {
      this.openAdminModal({
        modal: this.modals.REMOVE,
        data: {
          streams: [...this.streams],
          startId: stream.id
        }
      });
    },
    // @vuese
    // Open source stream modal
    showSourceModal(stream) {
      this.openAdminModal({
        modal: this.modals.SOURCE,
        data: { stream: stream }
      });
    },
    // @vuese
    // Open recorder stream modal
    showRecorderModal(stream) {
      this.openAdminModal({
        modal: this.modals.RECORDER,
        data: { stream: stream }
      });
    },
    // @vuese
    // Show detailed stream information
    showStreamInfoModal(stream) {
      this.openAdminModal({
        modal: this.modals.INFO,
        data: { stream: stream }
      });
    }
  }
};
</script>

<style scoped>
.streams-list {
  display: flex;
  flex-direction: column;
}

.streams-title-row {
  padding-bottom: 1em;
}

.manage-icon {
  margin-left: 0.5em;
}

.add-icon {
  padding: 3px 8px;
  border-radius: 50%;

  background-color: var(--sidebar-bg-color);
  color: var(--navbar-bg-color);

  cursor: pointer;
  user-select: none;

  transition: color var(--fast-transition),
    background-color var(--fast-transition);
}
.add-icon:hover {
  background-color: var(--navbar-bg-color);
  color: var(--main-bg-color);
}

.remove-icon {
  color: var(--navbar-bg-color);
  cursor: pointer;
}
.remove-icon:hover {
  color: var(--error-color);
}

.info-streams {
  display: flex;
  flex-direction: column;
}
.info-streams__wrapper {
  padding-left: 1em;
}

.info-stream-row {
  display: flex;
}
.title-row {
  margin-bottom: 0.5em;
}

.field {
  text-align: center;
  font-family: var(--sans-font);
}
.status-field {
  width: 150px;
}
.recorder-field {
  width: 160px;
}
.name-field {
  width: 150px;
}
.type-field {
  width: 100px;
}
.url-field {
  width: 100px;
  flex-grow: 1;
}
.actions-field {
  width: 100px;
}

@media only screen and (max-width: 400px) {
  .type-field {
    display: none;
  }
}

@media only screen and (max-width: 500px) {
  .name-field {
    flex-grow: 1;
    text-align: center;
  }
  .status-field {
    flex-grow: 1;
    text-align: start;
  }
  .url-field {
    display: none;
  }
  .recorder-field {
    flex-grow: 1;
    text-align: start;
  }
}

@media only screen and (max-width: 640px) {
  .title-row {
    font-size: var(--small-font-sz);
  }
}
</style>
